import { useEffect } from 'react';
import appConfig from '../config/appConfig';
import { isCookieValid } from '../lib/cookieUtils';

/**
 * AuthWrapper component that checks for authentication cookie on mount
 * Redirects to main site if UserId cookie doesn't exist or is expired
 */
const AuthWrapper = ({ children }) => {
  useEffect(() => {
    // Check if UserId cookie exists and is valid
    const isAuthenticated = isCookieValid(appConfig.auth.cookieName);
    
    if (!isAuthenticated) {
      console.log('UserId cookie not found or expired. Redirecting to main site...');
      window.location.href = appConfig.urls.mainSite;
    }
  }, []);

  return children;
};

export default AuthWrapper;

